import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from '../../../components/snackbar';
import { LeadTraceMatrix } from 'api/reports';
export default function LeadTraceMatrixSection({
  leadKeys = [],
  metrices = [],
  notNormalMetrices = [],
  initialValues = {},
  onChange = () => { },
  ecgReportData = {},
  inputFormData = {},
  isLTData,
  leadReplica
}) {
  const [formData, setFormData] = useState(initialValues);
  const [saving, setSaving] = useState(false);

  // const [formData, setFormData] = useState({
  //   lead_trace_quality: {},
  //   lead_2_q_pathalogical_wave: false,
  // });

  const { enqueueSnackbar } = useSnackbar();
  console.log(leadReplica)


  const otherMatrixDataMapping = () => {
    let otherMatrices = {
      r_peaks: [],
      lbbb: false,
      st_elevation: false,
      st_dipression: false,
      mi_all: false
    }
    if (ecgReportData) otherMatrices.r_peaks = ecgReportData?.characteristics?.r_peak_points ?? []
    // if (formInput?.classification_of_abnormality === "LBBB") otherMatrices.lbbb = true
    if (inputFormData?.classification_of_abnormality === "ST-T Changes") otherMatrices.st_elevation = true
    if (inputFormData?.classification_of_abnormality === "Myocardial Infraction") otherMatrices.mi_all = true
    if (inputFormData?.findings?.includes("ST- depression and T-wave inversion")) otherMatrices.st_dipression = true

    return otherMatrices
  }



  const ecg_quality_matrix = {
    ...formData,
    ...otherMatrixDataMapping()
  };





  // Initialize formData on first mount or when leadKeys change
  // useEffect(() => {
  //   let lead_trace_quality = {};
  //   if (initialValues?.lead_trace_quality) {
  //     lead_trace_quality = initialValues?.lead_trace_quality
  //   } else {
  //     leadKeys.forEach((lead) => {
  //       const leadKey = `${lead}`;
  //       lead_trace_quality[leadKey] = {
  //         ...metrices.reduce((acc, type, i) => {
  //           acc[type] = i === 0; // default: normal = true
  //           return acc;
  //         }, {}),
  //         ...(initialValues?.lead_trace_quality?.[leadKey] || {}),
  //       };
  //     });
  //   }
  //   const merged = {
  //     lead_trace_quality,
  //     lead_2_q_pathalogical_wave: initialValues?.lead_2_q_pathalogical_wave ?? false,
  //   };
  //   setFormData(merged);
  // }, []);
  const handleMatrixChange = (leadKey, type) => (e) => {
    const isNotNormal = notNormalMetrices?.includes(type)
    const updated = {
      ...formData,
      lead_trace_quality: {
        ...formData.lead_trace_quality,
        [leadKey]: {
          ...formData.lead_trace_quality[leadKey],
          [type]: e.target.checked,
          ...(isNotNormal ? { "normal": false } : {})
        },
      },
    };
    setFormData(updated);
    onChange(updated);
  };
  const handleGlobalChange = (field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const updated = { ...formData, [field]: value };
    setFormData(updated);
    onChange(updated);
  };
  const hasAnySelection = () => {
    if (formData.lead_2_q_pathalogical_wave) return true;
    const ltq = formData.lead_trace_quality || {};
    return Object.values(ltq).some((leadRow) =>
      Object.values(leadRow || {}).some(Boolean)
    );
  };
  const handleSubmit = async () => {
    if (!hasAnySelection()) {
      enqueueSnackbar(
        "Please select at least one lead quality option before saving.",
        { variant: "warning" }
      );
      return;
    }
    try {
      setSaving(true);
      const interpretationWR = leadReplica ? true: false;
      const response = await LeadTraceMatrix({ reportId: ecgReportData?.id, ecg_quality_matrix: ecg_quality_matrix, status: "completed", interpretationWR});
      if (response) {
        enqueueSnackbar("Data saved successfully!", { variant: "success" });
        setSaving(false);
        onChange(formData);   // notify parent on success
      } else {
        enqueueSnackbar("Failed to save data.", { variant: "error" });
        setSaving(false);
      }
    } catch (err) {
      console.error("Error while saving:", err);
      enqueueSnackbar("An error occurred while saving.", { variant: "error" });
    }
  };
  return (
    <Box p={2}>
      {/* Matrix */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="span" fontWeight="bold" gutterBottom>
          Lead Trace Quality:
        </Typography>
        {
          !isLTData &&
          ecgReportData?.interpretation_data?.ecg_quality_matrix?.status !== "completed" &&
          ecgReportData?.interpretation_request_status === "completed" && (
            <LoadingButton
              variant="contained"
              color="primary"
              size="small"
              loading={saving}
              onClick={handleSubmit}
            >
              Save Lead Quality
            </LoadingButton>
          )
        }



      </Box>
      {/* Global Flags */}
      <Box>
        <Box display="flex" flexDirection="column" gap={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!formData.lead_2_q_pathalogical_wave}
                onChange={handleGlobalChange('lead_2_q_pathalogical_wave')}
              />
            }
            label="Lead 2 Q-Pathological Wave"
          />
        </Box>
      </Box>
      {leadKeys?.length ? <Box mt={2} sx={{ maxWidth: '38vw', overflowX: 'auto' }}>
        <TableContainer component={Paper} sx={{ maxHeight: (leadKeys?.length === 1 ? 200 : 400), overflow: 'auto' }}>
          <Table stickyHeader size="small" aria-label="lead trace matrix">
            <TableHead>
              <TableRow>
                <TableCell sx={{
                  position: 'sticky',
                  top: 0,
                  left: 0,
                  zIndex: 3,
                  background: 'white',
                  fontWeight: 'bold',
                }}><strong>#</strong></TableCell>
                {metrices.map((type) => (
                  <TableCell key={type} align="center"
                    sx={{
                      position: 'sticky',
                      top: 0,
                      left: 0,
                      zIndex: 3,
                      background: 'white',
                      fontWeight: 'bold',
                    }}>
                    <strong>{type.replace(/_/g, ' ')?.replace(/\b\w/g, char => char.toUpperCase())}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {leadKeys.map((lead) => {
                const leadKey = `${lead}`;
                const leadData = formData.lead_trace_quality?.[leadKey] || {};
                return (
                  <TableRow key={lead}>
                    <TableCell
                      sx={{
                        width: '80px',
                        position: 'sticky',
                        left: 0,
                        background: 'white', // or your theme background
                        zIndex: 1, // ensure it stays above other cells
                        borderRight: '1px solid #E0E0E0',
                      }}
                    >{lead}</TableCell>
                    {metrices.map((type) => (
                      <TableCell key={type} align="center">
                        <Checkbox
                          checked={!!leadData[type]}
                          onChange={handleMatrixChange(leadKey, type)}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box> : null}
    </Box>
  );
}







